import React, { useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { Breadcrumb } from '../index';
import { pageContainerStyles } from './PageContainer.styles';

const PageContainer = ({
  children,
  breadcrumbs = [],
  title,
  currentPage,
  headerActions,
}) => {
  const { t } = useTranslation();
  const location = useLocation();

  const autoBreadcrumbs = useMemo(() => {
    if (breadcrumbs.length > 0) {
      return breadcrumbs;
    }

    const pathSegments = location.pathname
      .split('/')
      .filter(segment => segment);
    const generatedBreadcrumbs = [{ label: t('breadcrumbs.home'), path: '/' }];

    let currentPath = '';
    pathSegments.forEach((segment, index) => {
      if (!isNaN(segment)) return;

      currentPath += `/${segment}`;
      const breadcrumbKey = `breadcrumbs.${segment}`;

      const label = t(breadcrumbKey, { defaultValue: segment });

      if (index < pathSegments.length - 1) {
        generatedBreadcrumbs.push({
          label,
          path: currentPath,
        });
      }
    });

    return generatedBreadcrumbs;
  }, [location.pathname, breadcrumbs, t]);

  const defaultBreadcrumbs = autoBreadcrumbs;

  const renderBreadcrumbs = () => {
    return (
      <Box sx={pageContainerStyles.breadcrumbContainer}>
        <Breadcrumb items={defaultBreadcrumbs} current={currentPage} />
        {headerActions && (
          <Box sx={{ marginLeft: 'auto' }}>{headerActions}</Box>
        )}
      </Box>
    );
  };

  return (
    <Box sx={pageContainerStyles.wrapper}>
      {renderBreadcrumbs()}

      <Box sx={pageContainerStyles.container}>
        <Box sx={pageContainerStyles.content}>
          {title && (
            <Typography variant="h4" gutterBottom sx={{ mb: 3 }}>
              {title}
            </Typography>
          )}
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default PageContainer;
